import React from 'react';
import styled, { useTheme } from 'styled-components/macro';
import { MdAdd } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import { getSecondaryColor } from 'lib/context/theme/utils';

const Card = styled.div`
  height: 88px;
  border: 1px dashed ${({ theme }) => theme.colors.neutral[40]};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 7px;
  &:hover {
    background: ${({ theme }) => theme.colors.info[10]};
    border: 1px dashed ${({ theme }) => theme.colors.info[100]};
  }
`;
const CardContent = styled.div`
  display: flex;
  align-items: center;
`;
const CardTitle = styled.div`
  font-weight: 600;
  font-size: 15px;
  line-height: 24px;
  margin-left: 8px;
  color: ${({ theme }) => getSecondaryColor(theme, 100)};
`;

type Props = {
  handleClick: () => void;
};
export const CardAddQuote = ({ handleClick }: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Card onClick={() => handleClick()}>
      <CardContent>
        <MdAdd color={getSecondaryColor(theme, 100)} size={20} />
        <CardTitle>{t('Add Quote')}</CardTitle>
      </CardContent>
    </Card>
  );
};
